export function toURLSearchParams(params) {
  var data = new URLSearchParams();
  Object.keys(params).filter(function (key) {
    return !!key;
  }).forEach(function (key) {
    data.set(key, params[key]);
  });
  return data;
}